module.exports = require('./helpers/bundle-url').getBundleURL('4oUxu') + "logo.c51670a8.svg";